import React, { useState } from 'react';
import I18n from 'i18n-js';
import { RCButton, RCTextWithIcon } from '@reverbdotcom/cadence/components';
import { NudgeExploreIcon } from '@reverbdotcom/cadence/icons/react';
import { Listing } from '@reverbdotcom/commons/src/gql/graphql';

import BumpModalV2WithController from './footer_buttons/BumpButtonV2';
import { bumpRatePercentToDecimal } from '../bump/bump_helpers';
import { RCTextUtility } from '@reverbdotcom/cadence/components/RCText/RCText';

interface Props {
  listing: Listing;
}

export default function LowVisibilityPresentment({ listing }: Props) {
  const [showBumpModal, setShowBumpModal] = useState(false);
  const recommendedRate = listing.featuredListingInsight?.recommendedBumpRate ?? listing.bumpRecommendations?.bumpRecommendationAmount;
  const bumpRate = listing.bumpRate?.rate || 0;

  return (
    <>
      <div className="seller-listing-insight-presentment">
        <span className="seller-listing-insight-presentment__low-visibility">
          <RCTextWithIcon icon={<NudgeExploreIcon />} placement="left" size="large">
            <span className="weight-bold">
              {I18n.t('discovery.listingsManagement.sellerListingCard.insights.lowVisibility.title')}
            </span>
          </RCTextWithIcon>
        </span>
        <RCTextUtility size="350">
          {I18n.t('discovery.listingsManagement.sellerListingCard.insights.lowVisibility.bumpToBoost', {
            rate: recommendedRate,
          })}
        </RCTextUtility>
        <RCButton
          variant="outlined"
          size="small"
          onClick={() => setShowBumpModal(true)}
          fullWidth
        >
          {I18n.t('discovery.listingsManagement.sellerListingCard.promoteWithBump')}
        </RCButton>
      </div>

      <BumpModalV2WithController
        listingId={listing.id}
        bid={bumpRatePercentToDecimal(bumpRate)}
        showModal={showBumpModal}
        setShowModal={setShowBumpModal}
        listing={listing}
      />
    </>
  );
}
